/* import __COLOCATED_TEMPLATE__ from './debug-data.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import type CircuitService from 'simdds/services/circuit';

interface DebugDataSignature {
  Args: object;
  Element: HTMLDivElement;
}

export default class DebugDataPanel extends Component<DebugDataSignature> {
  @service declare circuit: CircuitService;

  get multipliers() {
    return this.circuit.partData?.multipliers?.length ? this.circuit.partData.multipliers.join(', ') : '-';
  }
}
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    DebugData: typeof DebugDataPanel;
  }
}
